import { create } from 'zustand';

interface AuthModalState {
  isOpen: boolean;
  tab: 'sign-in' | 'sign-up';
  successMessage?: string;
  showSuccess: boolean;
}

interface ModalState {
  authModal: AuthModalState;
  
  // Auth modal actions
  openAuthModal: (tab?: 'sign-in' | 'sign-up') => void;
  closeAuthModal: () => void;
  showAuthSuccess: (message: string) => void;
  resetAuthModal: () => void;
}

export const useModalStore = create<ModalState>((set) => ({
  authModal: {
    isOpen: false,
    tab: 'sign-in',
    showSuccess: false,
    successMessage: undefined
  },

  openAuthModal: (tab = 'sign-in') => 
    set((state) => ({
      authModal: {
        ...state.authModal,
        isOpen: true,
        tab,
        showSuccess: false,
        successMessage: undefined
      }
    })),

  closeAuthModal: () =>
    set((state) => ({
      authModal: {
        ...state.authModal,
        isOpen: false,
        showSuccess: false,
        successMessage: undefined
      }
    })),

  showAuthSuccess: (message: string) =>
    set((state) => ({
      authModal: {
        ...state.authModal,
        showSuccess: true,
        successMessage: message
      }
    })),

  resetAuthModal: () =>
    set({
      authModal: {
        isOpen: false,
        tab: 'sign-in',
        showSuccess: false,
        successMessage: undefined
      }
    })
})); 